/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', () => {
  const productJson = [...document.querySelectorAll('[data-product-json]')];
  if (productJson.length > 0) {
    productJson.forEach((product) => {
    const sectionId = "shopify-section-" + product.closest('[data-section-id]').dataset.sectionId;
    const productVariants = JSON.parse(product.innerHTML);
    const unavailableVariants = [];
    productVariants.variants.forEach((variant) => {
      if (variant.available === false) {
        unavailableVariants.push(variant);
      }
    });
    if (unavailableVariants.length > 0 && productVariants.options.length === 1) {
      const addToCartForm = document.querySelector('form[action="/cart/add"]');
      if (window.MutationObserver && addToCartForm.length) {
        const config = { childList: true, subtree: true };
        const variantOptions = [...document.querySelectorAll('#' + sectionId + ' .single-option-selector option')];
        unavailableVariants.forEach((item) => {
          variantOptions.forEach((option) => {
            if (option.value === item.title) option.remove();
          });
        });
      }
    }
    });
  }
});